<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="productUpdate" :updateData="updateProductDetail"></UPDATE>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

let userType = { 1: '代理', 2: '標準', 3: '行家', 4: '大師', 5: '傳奇' }
let statusArr = { 1: '啟用', 2: '禁用' }
let symbolType = { 2: '外汇', 3: '参考行情', 4: '商品', 5: '期指', 6: '货币', 7: '股票' }
let symbolField = []
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  methods: {
    bthClick(clickName, row) {
      if (clickName == 'productDetail') {
        this.productDetail(row)
      } else if (clickName == 'unsubscribe') {
        this.unsubscribe(row)
      }
    },
    unsubscribe(row) {
      this.dataChange(Url.signal.unsubscribe, {
        'signalKey': row.signalKey,
        'customerNumber': row.customerNumber,
        'companyId': row.companyId
      }, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    productDetail(row) {
      this.dataChange(Url.signal.productList, {
        'uniqueKey': row.signalKey,
        'assigningCompanyId': row.signalCompanyId
      }, res => {
        if (res.code == 0) {
          console.info(res)
          row.symbols = res.result.symbol
          this.updateProductDetail.cols = [
            { title: 'signalKey', field: 'signalKey', readonly: true },
            { title: '信号源交易账号', field: 'signalSubscribeNumber', readonly: true },
            { title: '跟单平台', field: 'platform', readonly: true },
            { title: '产品类型', field: 'symbolType', type: 3, optionList: symbolType, button: true }
          ]
          for (let i in res.result) {
            let optionList = []
            const symbolArr = res.result[i]
            for (let j in symbolArr) {
              if (symbolArr[j].checked) {
                optionList.push({ 'symbol': symbolArr[j].symbol })
              }
            }
            let field = 'product' + i
            symbolField.push(field)
            let col = {
              title: symbolType[i], field: field, type: 18, pageData: {
                selection: false,
                isPage: false,
                cols: [
                  { title: '产品', field: 'symbol' }
                ]
              }, optionList: optionList, data: [], hidden: (model, col) => {
                return model.symbolType != i
              }
            }
            this.updateProductDetail.cols.push(col)
          }
          this.$refs.productUpdate.open(row)
        } else {
          this.$message.error(res.message)
        }
      }, res => {
        console.log(res)
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '跟单客户账号', field: 'customerNumber' },
          { title: '跟单客户所属公司', field: 'companyId' },
          { title: '跟单客户所属业务', field: 'businessType' },
          { title: '信号源交易账号', field: 'signalSubscribeNumber' },
          { title: '信号源所属公司', field: 'signalCompanyId' },
          { title: '信号源所属业务', field: 'signalBusinessType' },
          { title: '開始時間', field: 'startTime', type: 5 },
          { title: '結束時間', field: 'endTime', type: 5 },
          { click: window.$t('common.search') }
        ]
      },
      updateProductDetail: {
        submit: 'hidden',
        modelName: '詳情',
        cols: [
          { title: 'signalKey', field: 'signalKey', required: true, readonly: true },
          { title: '信号源交易账号', field: 'signalSubscribeNumber', required: true, isNumber: true, readonly: true },
          { title: '跟单平台', field: 'platform', required: true, readonly: true },
          { title: '产品类型', field: 'symbolType', type: 3, optionList: symbolType, button: true, required: true }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.customerList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '信號源唯一鍵', field: 'signalKey' },
          { title: '跟單用戶的賬號ID', field: 'accountId' },
          { title: '跟单客户账号', field: 'customerNumber' },
          { title: '跟单客户所属公司', field: 'companyId' },
          { title: '跟单客户所属业务', field: 'businessType' },
          { title: '交易平台', field: 'platform' },
          {
            title: '开始跟单时间', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '跟单手数设置', field: 'volume' },
          { title: '跟单保证金设置', field: 'earnestMoney' },
          { title: '跟单总手数上限', field: 'maxTotalLotSize' },
          { title: '跟单总额上限', field: 'totalAmount' },
          { title: '保证金跟单止损设置', field: 'stopLoss' },
          { title: '保证金跟单止盈设置', field: 'stopProfit' },
          { title: '跟单止损', field: 'maxLoss' },
          { title: '跟单止损-平仓', field: 'stopLossClosePosition' },
          { title: '最大延时', field: 'maxDelay' },
          { title: '信号源姓名', field: 'signalName' },
          { title: '信号源交易账号', field: 'signalSubscribeNumber' },
          {
            title: '信號源狀態', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          {
            title: '信号源類型', field: 'signalUserType', render: (data, full) => {
              return userType[data]
            }
          },
          { title: '信号源所属公司', field: 'signalCompanyId' },
          { title: '信号源所属业务', field: 'signalBusinessType' },
          {
            title: '跟单产品',
            btnClick: [
              {
                name: '取消訂閱',
                click: 'unsubscribe',
                auth: 'signal:subscribe:cancel'
              },
              {
                name: '详情',
                click: 'productDetail'
              }
            ]
          }
        ]
      }
    }
  }
}
</script>
